module.exports = __webpack_public_path__ + "static/img/sl03.cc6896c03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sl03.png
// module id = TIB4
// module chunks = 0